/**
 * Author Drawer functionality
 */

class AuthorDrawer {
  constructor() {
    this.drawer = document.getElementById('AuthorDrawer');
    this.backdrop = document.getElementById('AuthorDrawerBackdrop');
    this.authorButtons = document.querySelectorAll('.fiona__more');
    this.closeButton = this.drawer?.querySelector('.author-drawer__close');

    this.bindEvents();
  }

  bindEvents() {
    // Open author drawer events
    this.authorButtons?.forEach(button => {
      button.addEventListener('click', this.openDrawer.bind(this));
    });

    // Close author drawer events
    this.closeButton?.addEventListener('click', this.closeDrawer.bind(this));
    this.backdrop?.addEventListener('click', this.closeDrawer.bind(this));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeDrawer();
    });
  }

  openDrawer() {
    this.drawer?.classList.add('is-active');
    this.backdrop?.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.drawer?.classList.remove('is-active');
    this.backdrop?.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}

export default AuthorDrawer;